import { render, staticRenderFns } from "./ViewSettingsTelegram.vue?vue&type=template&id=0f607116&scoped=true&"
import script from "./ViewSettingsTelegram.vue?vue&type=script&lang=js&"
export * from "./ViewSettingsTelegram.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettingsTelegram.vue?vue&type=style&index=0&id=0f607116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f607116",
  null
  
)

export default component.exports